module.exports = __webpack_public_path__ + "static/testimonials_background-93f988d2e17c1447bb30a8c6d57379ac.png";